import {
    FiCalendar,
    FiEdit2,
    FiFolder,
    FiDollarSign,
    FiTrash2,
    FiCreditCard,
} from "react-icons/fi";
import { formatCurrency } from "../../utils/formatCurrency";

export default function MovimientoTable({ data = [], loading, onEdit, onAnular }) {
    if (loading) return <p>Cargando movimientos...</p>;

    return (
        <div className="table-wrap">
            <table className="table-app">
                <thead>
                <tr>
                    <th>Fecha</th>
                    <th>Tipo</th>
                    <th>Descripción</th>
                    <th>Categoría</th>
                    <th>Cuenta</th>
                    <th>Tercero</th>
                    <th>Monto</th>
                    <th>Estado</th>
                    <th>Acción</th>
                </tr>
                </thead>
                <tbody>
                {data.length === 0 ? (
                    <tr>
                        <td colSpan="9" className="empty-state">
                            No hay movimientos registrados
                        </td>
                    </tr>
                ) : (
                    data.map((row) => (
                        <tr key={row.idMovimiento}>
                            <td>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                        <FiCalendar size={15} />
                                        {row.fechaMovimiento || "-"}
                                    </span>
                            </td>
                            <td>{row.tipoMovimiento || "-"}</td>
                            <td>{row.descripcion || "-"}</td>
                            <td>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                        <FiFolder size={15} />
                                        {row.categoriaNombre || "-"}
                                    </span>
                            </td>
                            <td>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                        <FiCreditCard size={15} />
                                        {row.cuentaNombre || "-"}
                                    </span>
                            </td>
                            <td>{row.tercero || "-"}</td>
                            <td>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                        <FiDollarSign size={15} />
                                        {formatCurrency(row.monto || 0)}
                                    </span>
                            </td>
                            <td>{row.estado || "-"}</td>
                            <td>
                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                    <button
                                        type="button"
                                        className="btn-secondary"
                                        onClick={() => onEdit(row)}
                                    >
                                        <FiEdit2 size={16} />
                                        Editar
                                    </button>

                                    <button
                                        type="button"
                                        className="btn-danger"
                                        onClick={() => onAnular(row)}
                                    >
                                        <FiTrash2 size={16} />
                                        Anular
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))
                )}
                </tbody>
            </table>
        </div>
    );
}